import styled from 'styled-components';
import _ from 'lodash';

import { Beads } from '~ui-kit';
import {
  getTransportStatusLabel,
  getStatusLabel,
  progressToBeadStates,
} from '~utils/status.utils';

const grey = '#cdd1de';

const TaskStatus = ({ progress, time, patientTransport, handler }) => {
  const handlerName = handler ? handler.split(' ')[0] : null;
  const beadStates = progressToBeadStates(progress);
  const active = _.findLast(progress, ({ time }) => time !== null);

  return (
    <Wrapper>
      <Beads beadStates={beadStates} />
      <Label>
        {patientTransport
          ? getTransportStatusLabel(active.orderStatus)
          : getStatusLabel(active.orderStatus)}
      </Label>
      <Time>{time}</Time>
      {handler && (
        <>
          <Line />
          <Handler>Kuljettaja: {handlerName}</Handler>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-wrap: nowrap;
  gap: 8px;
  align-items: end;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 14px;
`;

const Time = styled.div`
  display: inline-block;
  margin-left: 8px;
  white-space: nowrap;
  text-align: right;
  font-size: 12px;
  color: #313131;
`;

const Line = styled.hr`
  border: none;
  width: 100%;
  height: 1px;
  margin-top: -4px;
  margin-bottom: -4px;
  background-color: ${grey};
`;

const Handler = styled.div`
  font-weight: 400;
  font-size: 12px;
`;

export default TaskStatus;
